import { Avatar, Box, Tooltip } from "@mui/material";
import styles from "./CustomTable.module.css";
import ImageGallery from "./ImageViewer";

const SocialPosts = ({ seleceted, posts = 'sss' }) => {
    switch (seleceted?.channelType) {
        case 6:
            return <Box>
                <Box className={styles.social_page_name}>
                    <span>Twitter / X Preview</span>
                    <Tooltip title={'title'} placement={'top'} arrow componentsProps={{
                        tooltip: {
                            style: {
                                backgroundColor: 'var(--secondary)',
                                color: 'white',
                                fontSize: '.875rem',
                                padding: '.25rem .50rem',
                                borderRadius: '.3125rem'
                            },
                        },
                        arrow: {
                            style: {
                                color: 'var(--secondary)',
                            },
                        },
                    }}>
                        <img
                            src={process.env.REACT_APP_IMAGE_URL + "NewPost/info-icon.svg"}
                            className={styles.social_icon_img}
                            alt="media_connect_icon"
                        />
                    </Tooltip>
                </Box>
                <Box className={styles.body_wrap}>
                    <Box className={styles.common_wrap}>
                        {seleceted.profileUrl ?
                            <Box className={styles.social_page_img}>
                                <img
                                    src={seleceted?.profileUrl}
                                    className={styles.img_icon}
                                    alt="profile"
                                />
                            </Box> : seleceted.profileUrl ?
                                <Avatar alt={seleceted?.profileName} src="/broken-image.jpg"
                                >
                                    {seleceted?.profileName?.slice(0, 1)}
                                </Avatar> :
                                <Avatar alt="centilio" src="/broken-image.jpg"
                                >
                                    c
                                </Avatar>}
                        <Box className={styles.twitter_profiles}>
                            <Box className={styles.user_name}>{seleceted?.profileName}</Box>
                            <Box className={styles.user_sub_name}>@{seleceted?.profileName}</Box>
                        </Box>
                    </Box>
                    <Box sx={{ padding: '0px 0px 0px 52px' }}>
                        <Box className={styles.social_post_text}>{posts}</Box>
                        {seleceted?.file_id && (
                            <Box>
                                <ImageGallery
                                    images={seleceted.file_id.map(
                                        (img) => `${process.env.REACT_APP_SOCIAL_ATTACHMENT_DRIVE}?file_id=${img}`
                                    )}
                                />
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>
        case 4:
            return <Box>
                <Box className={styles.social_page_name}>
                    <span>Facebook Preview</span>
                    <Tooltip title={'title'} placement={'top'} arrow componentsProps={{
                        tooltip: {
                            style: {
                                backgroundColor: 'var(--secondary)',
                                color: 'white',
                                fontSize: '.875rem',
                                padding: '.25rem .50rem',
                                borderRadius: '.3125rem'
                            },
                        },
                        arrow: {
                            style: {
                                color: 'var(--secondary)',
                            },
                        },
                    }}>
                        <img
                            src={process.env.REACT_APP_IMAGE_URL + "NewPost/info-icon.svg"}
                            className={styles.social_icon_img}
                            alt="media_connect_icon"
                        />
                    </Tooltip>
                </Box>
                <Box className={styles.body_wrap}>
                    <Box className={styles.facebook_preview}>
                        <Box className={styles.common_wrap} sx={{ padding: '10px', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', gap: '10px' }}>
                                {seleceted.profileUrl ?
                                    <Box className={styles.social_page_img}>
                                        <img
                                            src={seleceted?.profileUrl}
                                            className={styles.img_icon}
                                            alt="profile"
                                        />
                                    </Box> : seleceted.profileUrl ?
                                        <Avatar alt={seleceted.profileName} src="/broken-image.jpg"
                                        >
                                            {seleceted?.profileName?.slice(0, 1)}
                                        </Avatar> :
                                        <Avatar alt="centilio" src="/broken-image.jpg"
                                        >
                                            c
                                        </Avatar>}
                                <Box>
                                    <Box className={styles.user_name}>{seleceted?.profileName}</Box>
                                    <Box className={styles.common_title_text}>
                                        <span className={styles.user_sub_name}>Just Now</span>
                                        <img
                                            src={process.env.REACT_APP_IMAGE_URL + "NewPost/earth-planet.svg"}
                                            className={styles.earth_planet_img}
                                            alt="just_now"
                                        />
                                    </Box>
                                </Box>
                            </Box>
                            <img
                                src={process.env.REACT_APP_IMAGE_URL + "NewPost/three-dots.svg"}
                                className={styles.three_dot_img}
                                alt="media_connect_icon"
                            />
                        </Box>
                        <Box className={styles.social_post_text} sx={{ marginLeft: '12px' }}>{posts}</Box>
                        {seleceted?.file_id && (
                            <Box>
                                <ImageGallery
                                    images={seleceted.file_id.map(
                                        (img) => `${process.env.REACT_APP_SOCIAL_ATTACHMENT_DRIVE}?file_id=${img}`
                                    )}
                                />
                            </Box>
                        )}
                        <Box className={styles.facebook_btn}>
                            <Box className={styles.facebook_bottm_container}>
                                <img
                                    src={process.env.REACT_APP_IMAGE_URL + "NewPost/thumbs-up.svg"}
                                    className={styles.bottom_icon_img}
                                    alt="like"
                                />
                                <span>Like</span>
                            </Box>
                            <Box className={styles.facebook_bottm_container}>
                                <img
                                    src={process.env.REACT_APP_IMAGE_URL + "NewPost/comment-box.svg"}
                                    className={styles.bottom_icon_img}
                                    alt="comment"
                                />
                                <span>Comment</span>
                            </Box>
                            <Box className={styles.facebook_bottm_container}>
                                <img
                                    src={process.env.REACT_APP_IMAGE_URL + "NewPost/share.svg"}
                                    className={styles.bottom_icon_img}
                                    alt="share"
                                />
                                <span>Share</span>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>

        case 5:
            return <Box>
                <Box className={styles.social_page_name}>
                    <span>Instagram Preview</span>
                    <Tooltip title={'title'} placement={'top'} arrow componentsProps={{
                        tooltip: {
                            style: {
                                backgroundColor: 'var(--secondary)',
                                color: 'white',
                                fontSize: '.875rem',
                                padding: '.25rem .50rem',
                                borderRadius: '.3125rem'
                            },
                        },
                        arrow: {
                            style: {
                                color: 'var(--secondary)',
                            },
                        },
                    }}>
                        <img
                            src={process.env.REACT_APP_IMAGE_URL + "NewPost/info-icon.svg"}
                            className={styles.social_icon_img}
                            alt="media_connect_icon"
                        />
                    </Tooltip>
                </Box>
                <Box className={styles.body_wrap}>
                    <Box className={styles.facebook_preview}>
                        <Box className={styles.common_wrap} sx={{ justifyContent: 'space-between', padding: '10px' }}>
                            <Box className={styles.common_title_text}>
                                {seleceted.profileUrl ?
                                    <Box className={styles.social_page_img}>
                                        <img
                                            src={seleceted?.profileUrl}
                                            className={styles.img_icon}
                                            alt="profile"
                                        />
                                    </Box> : seleceted.profileUrl ?
                                        <Avatar alt={seleceted.profileName} src="/broken-image.jpg"
                                        >
                                            {seleceted?.profileName?.slice(0, 1)}
                                        </Avatar> :
                                        <Avatar alt="centilio" src="/broken-image.jpg"
                                        >
                                            c
                                        </Avatar>}
                                <Box className={styles.user_name}>{seleceted?.profileName}</Box>
                            </Box>
                            <img
                                src={process.env.REACT_APP_IMAGE_URL + "NewPost/three-dots.svg"}
                                className={styles.three_dot_img}
                                alt="media_connect_icon"
                            />
                        </Box>
                        {seleceted?.file_id && (
                            <Box>
                                <ImageGallery
                                    images={seleceted.file_id.map(
                                        (img) => `${process.env.REACT_APP_SOCIAL_ATTACHMENT_DRIVE}?file_id=${img}`
                                    )}
                                />
                            </Box>
                        )}
                        {seleceted?.file_idd && <Box className={styles.common_wrap} sx={{ justifyContent: 'space-between', padding: '10px' }}>
                            <Box className={styles.facebook_bottm_container} sx={{ gap: '10px' }}>
                                <img
                                    src={process.env.REACT_APP_IMAGE_URL + "NewPost/insta-like.svg"}
                                    className={styles.bottom_icon_img}
                                    alt="insta_like_icon"
                                />
                                <img
                                    src={process.env.REACT_APP_IMAGE_URL + "NewPost/insta-comment.svg"}
                                    className={styles.bottom_icon_img}
                                    alt="insta_comment_icon"
                                />
                                <img
                                    src={process.env.REACT_APP_IMAGE_URL + "NewPost/insta-share.svg"}
                                    className={styles.bottom_icon_img}
                                    alt="insta_share_icon"
                                />
                            </Box>
                            <img
                                src={process.env.REACT_APP_IMAGE_URL + "NewPost/bookmark.svg"}
                                className={styles.bottom_icon_img}
                                alt="bookmark_icon"
                            />
                        </Box>}
                        {posts && <Box className={styles.insta_bottom_text}>
                            <Box sx={{ fontWeight: '600' }}>{seleceted?.profileName}</Box>
                            <Box className={styles.social_post_text}>{posts}</Box>
                        </Box>}
                    </Box>
                </Box>
            </Box>

        case 8:
            return <Box>
                <Box className={styles.social_page_name}>
                    <span>LinkedIn Preview</span>
                    <Tooltip title={'title'} placement={'top'} arrow componentsProps={{
                        tooltip: {
                            style: {
                                backgroundColor: 'var(--secondary)',
                                color: 'white',
                                fontSize: '.875rem',
                                padding: '.25rem .50rem',
                                borderRadius: '.3125rem'
                            },
                        },
                        arrow: {
                            style: {
                                color: 'var(--secondary)',
                            },
                        },
                    }}>
                        <img
                            src={process.env.REACT_APP_IMAGE_URL + "NewPost/info-icon.svg"}
                            className={styles.social_icon_img}
                            alt="media_connect_icon"
                        />
                    </Tooltip>
                </Box>
                <Box className={styles.body_wrap}>
                    <Box className={styles.facebook_preview}>
                        <Box className={styles.common_wrap} sx={{ padding: '10px', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', gap: '10px' }}>
                                {!seleceted.profileUrl==="No Logo" ?
                                    <Box className={styles.social_page_img}>
                                        <img
                                            src={seleceted?.profileUrl}
                                            className={styles.img_icon}
                                            alt="profile"
                                        />
                                    </Box> : seleceted.profileUrl==="No Logo" ?
                                        <Avatar alt={seleceted.profileName} src="/broken-image.jpg"
                                        >
                                            {seleceted?.profileName?.slice(0, 1)}
                                        </Avatar> :
                                        <Box className={styles.social_page_img}>
                                            <img
                                                src={process.env.REACT_APP_IMAGE_URL + "NewPost/linkedInSocial.svg"}
                                                className={styles.img_icon}
                                                alt="profile"
                                            />
                                        </Box>}
                                <Box>
                                    <Box className={styles.user_name}>{seleceted?.profileName}</Box>
                                    <Box className={styles.common_title_text}>
                                        <span className={styles.user_sub_name}>Just Now</span>
                                        <img
                                            src={process.env.REACT_APP_IMAGE_URL + "NewPost/earth-planet.svg"}
                                            className={styles.earth_planet_img}
                                            alt="just_now"
                                        />
                                    </Box>
                                </Box>
                            </Box>
                            <img
                                src={process.env.REACT_APP_IMAGE_URL + "NewPost/three-dots.svg"}
                                className={styles.three_dot_img}
                                alt="three_dots"
                            />
                        </Box>
                        <Box className={styles.social_post_text} sx={{ marginLeft: '12px' }}>{posts}</Box>
                        {seleceted?.file_id && (
                            <Box>
                                <ImageGallery
                                    images={seleceted.file_id.map(
                                        (img) => `${process.env.REACT_APP_SOCIAL_ATTACHMENT_DRIVE}?file_id=${img}`
                                    )}
                                />
                            </Box>
                        )}
                        <Box className={styles.border_line} />
                        <Box className={styles.facebook_btn}>
                            <Box className={styles.linkedIn_container}>
                                <img
                                    src={process.env.REACT_APP_IMAGE_URL + "NewPost/thumbs-up.svg"}
                                    className={styles.bottom_icon_img}
                                    alt="like"
                                />
                                <Box className={styles.icon_text}>Like</Box>
                            </Box>
                            <Box className={styles.linkedIn_container}>
                                <img
                                    src={process.env.REACT_APP_IMAGE_URL + "NewPost/comment-box.svg"}
                                    style={{ width: '15px', height: '15px' }}
                                    alt="comment"
                                />
                                <Box className={styles.icon_text}>Comment</Box>
                            </Box>
                            <Box className={styles.linkedIn_container}>
                                <img
                                    src={process.env.REACT_APP_IMAGE_URL + "NewPost/repost-icon.svg"}
                                    className={styles.bottom_icon_img}
                                    alt="repost"
                                />
                                <Box className={styles.icon_text}>Repost</Box>
                            </Box>
                            <Box className={styles.linkedIn_container}>
                                <img
                                    src={process.env.REACT_APP_IMAGE_URL + "NewPost/share.svg"}
                                    className={styles.bottom_icon_img}
                                    alt="send"
                                />
                                <Box className={styles.icon_text}>Send</Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        default:
            break;
    }
};

export default SocialPosts;